module.exports = __webpack_public_path__ + "img/lg_ring_g_o_1_1@2x.3a62ecb3.png";